// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { LAYOUT } from 'constant/layout.constant'
import { GALLERY_URL, GALLERY_MODULE } from 'constant/url.constant'

// UI
const { GallerypageIndex } = lazily(() => import('pages/webpage/gallery'))

const galleryRoutes: IRoute[] = [
  {
    path: GALLERY_URL.INDEX,
    component: GallerypageIndex,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: GALLERY_MODULE,
      requireAuth: false,
      attrs: {
        label: 'gallery.gallery',
      },
    },
  },
]

export { galleryRoutes }
